import React from "react";

interface IncDecCounterProps {
  minLimit?: number;
  maxLimit?: number;
  current?: number;
  setCurrent?: (value?: number) => void;
  label?: string;
}
const IncDecCounter = (props: IncDecCounterProps) => {
  const {
    minLimit = 1,
    maxLimit = 99,
    current = 1,
    setCurrent = () => {},
    label = null,
  } = props;
  return (
    <div className="flex flex-col 1xl:w-[150px] lg:w-[125px] w-[100px] gap-[2px] ">
      {label && (
        <p className="text-base leading-[20.83px] font-normal text-txtParagraph">
          {label}
        </p>
      )}
      <div className="w-full flex items-center justify-center border-strokePrimary text-txtSecondary border rounded-md">
        <span
          className={`w-fit p-[10px] grid place-items-center border-e border-strokePrimary cursor-pointer`}
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            if (current !== minLimit) setCurrent(current - 1);
          }}
        >
          <DecCounter />
        </span>
        <p className="w-full grid place-items-center">{current}</p>
        <span
          className={`w-fit p-[10px] grid place-items-center border-s border-strokePrimary cursor-pointer`}
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            if (current !== maxLimit) setCurrent(current + 1);
          }}
        >
          <IncCounter />
        </span>
      </div>
    </div>
  );
};

const DecCounter = (props: any) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 10.125H5C4.96985 10.125 4.93857 10.1127 4.91293 10.0871C4.88728 10.0614 4.875 10.0301 4.875 10C4.875 9.96985 4.88728 9.93857 4.91293 9.91293C4.93857 9.88728 4.96985 9.875 5 9.875H15C15.0301 9.875 15.0614 9.88728 15.0871 9.91293C15.1127 9.93857 15.125 9.96985 15.125 10C15.125 10.0301 15.1127 10.0614 15.0871 10.0871C15.0614 10.1127 15.0301 10.125 15 10.125Z"
      fill="var(--color-stroke-active)"
      stroke="var(--color-stroke-active)"
    />
  </svg>
);

const IncCounter = (props: any) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 10.125H5C4.96985 10.125 4.93857 10.1127 4.91293 10.0871C4.88728 10.0614 4.875 10.0301 4.875 10C4.875 9.96985 4.88728 9.93857 4.91293 9.91293C4.93857 9.88728 4.96985 9.875 5 9.875H15C15.0301 9.875 15.0614 9.88728 15.0871 9.91293C15.1127 9.93857 15.125 9.96985 15.125 10C15.125 10.0301 15.1127 10.0614 15.0871 10.0871C15.0614 10.1127 15.0301 10.125 15 10.125Z"
      fill="var(--color-icon-bright)"
      stroke="#6D77A0"
    />
    <path
      d="M10 15.125C9.96985 15.125 9.93857 15.1127 9.91293 15.0871C9.88728 15.0614 9.875 15.0301 9.875 15V5C9.875 4.96985 9.88728 4.93857 9.91293 4.91293C9.93857 4.88728 9.96985 4.875 10 4.875C10.0301 4.875 10.0614 4.88728 10.0871 4.91293C10.1127 4.93857 10.125 4.96985 10.125 5V15C10.125 15.0301 10.1127 15.0614 10.0871 15.0871C10.0614 15.1127 10.0301 15.125 10 15.125Z"
      fill="var(--color-icon-bright)"
      stroke="#6D77A0"
    />
  </svg>
);

export default IncDecCounter;
